import { jsx as _jsx } from "react/jsx-runtime";
var Fullscreen = function Fullscreen(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.0016 4.02543C19.5516 4.02843 19.9966 4.47443 19.9966 5.02443L19.9996 9.99943C20.0006 10.5514 19.5526 11.0004 19.0006 11.0004H18.9996C18.4476 11.0004 18.0006 10.5524 17.9996 10.0014L17.9976 7.41643L14.7066 10.7074C14.5116 10.9024 14.2556 11.0004 13.9996 11.0004C13.7446 11.0004 13.4886 10.9024 13.2926 10.7074C12.9026 10.3164 12.9026 9.68343 13.2926 9.29343L16.5726 6.01343L13.9956 6.00043C13.4426 5.99743 12.9966 5.54643 12.9996 4.99543C13.0026 4.44443 13.4506 4.00043 13.9996 4.00043H14.0046L19.0016 4.02543ZM9.29302 13.293C9.68401 12.902 10.316 12.902 10.707 13.293C11.098 13.684 11.098 14.316 10.707 14.707L7.41501 17.999L10 18C10.553 18 11 18.448 11 19.001C10.999 19.553 10.552 20 10 20H9.99901L5.02402 19.997C4.47402 19.997 4.02802 19.552 4.02502 19.002L4.00002 14.005C3.99702 13.453 4.44302 13.003 4.99502 13H5.00002C5.55001 13 5.99701 13.444 6.00002 13.995L6.01302 16.573L9.29302 13.293Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default Fullscreen;